import { Button, CircularProgress } from '@mui/material';

export const LoadingButton = ({ text, loading, ...props }) => {
  return (
    <Button {...props} disabled={loading}>
      {text}
      {loading && <CircularProgress size={20} style={{ marginLeft: 10 }} />}
    </Button>
  );
};
